module.exports = "/_next/static/images/effcf546ecf6b492d51284289cccc9dc-rewards-illustration@0.5x.png";